import { useState } from 'react'
import { ChevronDown, ChevronUp, X } from 'lucide-react'
import CTAButton from '@/components/shared/CTAButton'
import PreservedLink from '@/components/shared/PreservedLink'
import { lendersData, vehicleMakesData } from '@/shared/navigationData'

const MobileNavPopout = ({ isOpen, onClose }) => {
  const [expandedSection, setExpandedSection] = useState(null)

  if (!isOpen) return null

  const toggleSection = section => {
    setExpandedSection(expandedSection === section ? null : section)
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />
      <button
        onClick={onClose}
        className="absolute top-6 right-6 z-60 transform rounded-lg bg-gradient-to-r from-red-500 to-red-600 p-2 shadow-lg transition-all duration-200 ease-in-out hover:scale-105 hover:from-red-600 hover:to-red-700 hover:shadow-xl"
        aria-label="Close menu"
      >
        <X className="h-5 w-5 stroke-2 text-white" />
      </button>
      <div className="relative max-h-[80vh] w-full max-w-md overflow-y-auto rounded-lg bg-white shadow-2xl">
        <div className="p-6">
          <div className="space-y-4">
            <MobileNavSection
              title="Lenders"
              items={lendersData}
              isExpanded={expandedSection === 'lenders'}
              onToggle={() => toggleSection('lenders')}
              onClose={onClose}
            />
            <MobileNavSection
              title="Vehicles"
              items={vehicleMakesData}
              isExpanded={expandedSection === 'vehicles'}
              onToggle={() => toggleSection('vehicles')}
              onClose={onClose}
            />
            <MobileNavLink to="/about-us" onClick={onClose}>
              About Us
            </MobileNavLink>
            <MobileNavLink to="/contact" onClick={onClose}>
              Contact Us
            </MobileNavLink>
            <div className="pt-4">
              <CTAButton className="w-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const MobileNavSection = ({ title, items, isExpanded, onToggle, onClose }) => {
  return (
    <div className="border-b border-gray-200 pb-4">
      <button
        onClick={onToggle}
        className="flex w-full items-center justify-between py-3 text-left text-lg font-semibold transition-colors hover:text-[oklch(0.6942_0.1185_194.77)]"
      >
        {title}
        {isExpanded ? (
          <ChevronUp className="h-5 w-5" />
        ) : (
          <ChevronDown className="h-5 w-5" />
        )}
      </button>
      {isExpanded && (
        <div className="mt-2 space-y-2 pl-4">
          {items.map(item => (
            <PreservedLink
              key={item.title}
              to={item.href}
              onClick={onClose}
              className="block py-2 text-sm transition-colors hover:text-[oklch(0.6942_0.1185_194.77)]"
            >
              {item.title}
            </PreservedLink>
          ))}
        </div>
      )}
    </div>
  )
}

const MobileNavLink = ({ to, children, onClick }) => {
  return (
    <PreservedLink
      to={to}
      onClick={onClick}
      className="block border-b border-gray-200 py-3 text-lg font-semibold transition-colors hover:text-[oklch(0.6942_0.1185_194.77)]"
    >
      {children}
    </PreservedLink>
  )
}

export default MobileNavPopout
